/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Decision_SummaryInputs */

const en_directory_detail_decision_summary = /** @type {(inputs: Directory_Detail_Decision_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decision summary`)
};

const zh_directory_detail_decision_summary = /** @type {(inputs: Directory_Detail_Decision_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`决策摘要`)
};

/**
* | output |
* | --- |
* | "Decision summary" |
*
* @param {Directory_Detail_Decision_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_decision_summary = /** @type {((inputs?: Directory_Detail_Decision_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Decision_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_decision_summary(inputs)
	return zh_directory_detail_decision_summary(inputs)
});
export { directory_detail_decision_summary as "directory.detail.decision_summary" }